import { ProFormCheckbox as OriginalProFormCheckbox } from '@ant-design/pro-components';
import { withWrap } from '../../utils/hoc';
const ProFormCheckbox = withWrap(OriginalProFormCheckbox);
ProFormCheckbox.Group = withWrap(OriginalProFormCheckbox.Group);
export default ProFormCheckbox;
